import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CurrentUserService } from './current-user.service';

@Injectable()
export class PrivilegeGuard implements CanActivate {

  constructor(
    private currentUserService: CurrentUserService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const required = route.data['requiredPrivileges'] as string[] | undefined;
    return this.currentUserService.ensureLoaded().pipe(
      map((user) => {
        if (user === null) {
          this.router.navigate(['/pages/error']);
          return false;
        }
        if (this.currentUserService.hasAnyPrivilege(required ?? [])) {
          return true;
        }
        this.router.navigate(['/pages/unauthorized']);
        return false;
      })
    );
  }
}
